// extracted by mini-css-extract-plugin
export default {"wrapper":"Sn-z","response":"Tn-z","error":"Un-z","disabled":"Vn-z","buttons":"Wn-z","feedbackQuestionSection":"Xn-z","yesNoWrapper":"Yn-z"};